import Base from 'app/models/base';

export default Base.extend({

  weight() {
    return this.get('weight');
  },


  dimensions() {
    if (this.get('length')) {
      return `${this.get('length')} x ${this.get('width')} x ${this.get('height')}`;
    }

    return '';
  },
});



// WEBPACK FOOTER //
// ./app/models/parcel.js